/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 * Constants for the Table component
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.0.0
 */

/*
* -------------------------------------------
*           FAST ACTIONS
* -------------------------------------------
*/

export const SET_BASKET_CONTEXT = '@@b2b_portal_ui/table/SET_BASKET_CONTEXT';
export const FAST_ACTION_SWITCH_CHECKBOX = '@@b2b_portal_ui/table/FAST_ACTION_SWITCH_CHECKBOX';
export const SET_IS_FAST_ACTION_PAGE = '@@b2b_portal_ui/table/SET_IS_FAST_ACTION_PAGE';
export const SET_IS_FAST_BASKET_PAGE = '@@b2b_portal_ui/table/SET_IS_FAST_BASKET_PAGE';

/*
* -------------------------------------------
*           SET TABLE CURRENT NAME
* -------------------------------------------
*/

export const SET_TABLE_CURRENT_NAME = '@@b2b_portal_ui/table/SET_TABLE_CURRENT_NAME';

/*
* -------------------------------------------
*           LOAD TABLE META
* -------------------------------------------
*/

export const LOAD_TABLE_META = '@@b2b_portal_ui/table/LOAD_TABLE_META';
export const LOAD_TABLE_META_ERROR = '@@b2b_portal_ui/table/LOAD_TABLE_META_ERROR';
export const LOAD_TABLE_META_SUCCESSFUL = '@@b2b_portal_ui/table/LOAD_TABLE_META_SUCCESSFUL';
export const LOAD_TABLE_META_PARAMETERS_SUCCESSFUL = '@@b2b_portal_ui/table/LOAD_TABLE_META_PARAMETERS_SUCCESSFUL';

/*
* -------------------------------------------
*           LOAD TABLE LIST
* -------------------------------------------
*/

export const LOAD_TABLE_LIST = '@@b2b_portal_ui/table/LOAD_TABLE_LIST';
export const LOAD_TABLE_LIST_FULLY = '@@b2b_portal_ui/table/LOAD_TABLE_LIST_FULLY';
export const LOAD_TABLE_LIST_ERROR = '@@b2b_portal_ui/table/LOAD_TABLE_LIST_ERROR';
export const LOAD_TABLE_LIST_SUCCESSFUL = '@@b2b_portal_ui/table/LOAD_TABLE_LIST_SUCCESSFUL';

/*
* -------------------------------------------
*           LOAD TABLE SUB ROWS
* -------------------------------------------
*/
export const ADD_TABLE_SUB_ROW_ID = '@@b2b_portal_ui/table/ADD_TABLE_SUB_ROW_ID';
export const COLLAPSE_TABLE_SUB_ROWS = '@@b2b_portal_ui/table/COLLAPSE_TABLE_SUB_ROWS';
export const LOAD_TABLE_SUB_ROW = '@@b2b_portal_ui/table/LOAD_TABLE_SUB_ROW';
export const LOAD_TABLE_SUB_ROW_ERROR = '@@b2b_portal_ui/table/LOAD_TABLE_SUB_ROW_ERROR';
export const SET_TABLE_SUB_ROW_DATA = '@@b2b_portal_ui/table/SET_TABLE_SUB_ROW_DATA';
export const SET_TABLE_SUB_ROW_MESSAGE = '@@b2b_portal_ui/table/SET_TABLE_SUB_ROW_MESSAGE';

/*
* -------------------------------------------
*           LOAD TABLE FIELDS
* -------------------------------------------
*/

export const LOAD_TABLE_FIELDS = '@@b2b_portal_ui/table/LOAD_TABLE_FIELDS';
export const LOAD_TABLE_FIELDS_ERROR = '@@b2b_portal_ui/table/LOAD_TABLE_FIELDS_ERROR';
export const LOAD_TABLE_FIELDS_SUCCESSFUL = '@@b2b_portal_ui/table/LOAD_TABLE_FIELDS_SUCCESSFUL';

/*
* -------------------------------------------
*         LOAD TABLE FILTER AND SORT
* -------------------------------------------
*/

export const LOAD_TABLE_FILTER_AND_SORT = '@@b2b_portal_ui/account/LOAD_TABLE_FILTER_AND_SORT';
export const LOAD_TABLE_FILTER_AND_SORT_ERROR = '@@b2b_portal_ui/account/LOAD_TABLE_FILTER_AND_SORT_ERROR';
export const LOAD_TABLE_FILTER_AND_SORT_SUCCESSFUL = '@@b2b_portal_ui/account/LOAD_TABLE_FILTER_AND_SORT_SUCCESSFUL';

/*
* -------------------------------------------
*          SEND TABLE FIELDS
* -------------------------------------------
*/

export const SEND_TABLE_FIELDS = '@@b2b_portal_ui/table/SEND_TABLE_FIELDS';
export const SEND_TABLE_FIELDS_SIZE = '@@b2b_portal_ui/table/SEND_TABLE_FIELDS_SIZE';

/*
* -------------------------------------------
*          SET TABLE FILTER & SORT
* -------------------------------------------
*/

export const SET_TABLE_FILTER = '@@b2b_portal_ui/table/SET_TABLE_FILTER';
export const SET_TABLE_SORT = '@@b2b_portal_ui/table/SET_TABLE_SORT';
export const SEND_TABLE_FILTER_AND_SORT_ERROR = '@@b2b_portal_ui/table/SEND_TABLE_FILTER_AND_SORT_ERROR';
export const SEND_TABLE_FILTER_AND_SORT_SUCCESSFUL = '@@b2b_portal_ui/table/SEND_TABLE_FILTER_AND_SORT_SUCCESSFUL';

export const SET_TABLE_FILTER_PRESET = '@@b2b_portal_ui/table/SET_TABLE_FILTER_PRESET';


/*
* -------------------------------------------
*                CHECKBOX
* -------------------------------------------
*/

export const SET_TABLE_MAIN_CHECKBOX = '@@b2b_portal_ui/table/SET_TABLE_MAIN_CHECKBOX';
export const SET_TABLE_MAIN_CHECKBOX_ERROR = '@@b2b_portal_ui/table/SET_TABLE_MAIN_CHECKBOX_ERROR';
export const SWITCH_CHECKBOX = '@@b2b_portal_ui/table/SWITCH_CHECKBOX';
export const SWITCH_CHECKBOX_LOADING = '@@b2b_portal_ui/table/SWITCH_CHECKBOX_LOADING';
export const SWITCH_CHECKBOX_SUCCESSFUL = '@@b2b_portal_ui/table/SWITCH_CHECKBOX_SUCCESSFUL';
export const SWITCH_CHECKBOX_ERROR = '@@b2b_portal_ui/table/SWITCH_CHECKBOX_ERROR';
export const GET_BASKET_COUNT = '@@b2b_portal_ui/table/GET_BASKET_COUNT';
export const GET_BASKET_COUNT_SUCCESSFUL = '@@b2b_portal_ui/table/GET_BASKET_COUNT_SUCCESSFUL';
export const GET_BASKET_COUNT_FAILED = '@@b2b_portal_ui/table/GET_BASKET_COUNT_FAILED';
export const SET_BASKET_VALID = '@@b2b_portal_ui/table/SET_BASKET_VALID';
export const SET_BASKET_PARAMS = '@@b2b_portal_ui/table/SET_BASKET_PARAMS';

/*
* -------------------------------------------
*            DROP FILTER & SORT
* -------------------------------------------
*/

export const DROP_TABLE_FILTER_AND_SORT = '@@b2b_portal_ui/table/DROP_TABLE_FILTER_AND_SORT';

/*
* -------------------------------------------
*                SEND SEARCH
* -------------------------------------------
*/

export const SEND_TABLE_SEARCH = '@@b2b_portal_ui/table/SEND_TABLE_SEARCH';
export const SEND_TABLE_SEARCH_ERROR = '@@b2b_portal_ui/table/SEND_TABLE_SEARCH_ERROR';
export const SEND_TABLE_SEARCH_SUCCESSFUL = '@@b2b_portal_ui/table/SEND_TABLE_SEARCH_SUCCESSFUL';

/*
* -------------------------------------------
*                SEND SUGGEST
* -------------------------------------------
*/
export const SEND_FIELD_SUGGEST = '@@b2b_portal_ui/table/SEND_FIELD_SUGGEST';
export const SEND_FIELD_SUGGEST_FAILED = '@@b2b_portal_ui/table/SEND_FIELD_SUGGEST_FAILED';
export const SEND_FIELD_SUGGEST_SUCCESSFUL = '@@b2b_portal_ui/table/SEND_FIELD_SUGGEST_SUCCESSFUL';

/*
* -------------------------------------------
*           FOOTER MODAL
* -------------------------------------------
*/

export const CHANGE_TABLE_MODAL_VALUE = '@@b2b_portal_ui/table/CHANGE_TABLE_MODAL_VALUE';
export const OPEN_BASKET = '@@b2b_portal_ui/table/OPEN_BASKET';
export const OPEN_CREATE_INQUIRY = '@@b2b_portal_ui/table/OPEN_CREATE_INQUIRY';
export const OPEN_LABEL_EDITOR = '@@b2b_portal_ui/table/OPEN_LABEL_EDITOR';
export const OPEN_MOBILE_CHANGROLE = '@@b2b_portal_ui/table/OPEN_MOBILE_CHANGROLE';
export const OPEN_MOBILE_CHANGE_TARIFF = '@@b2b_portal_ui/table/OPEN_MOBILE_CHANGE_TARIFF';
export const OPEN_MOBILE_CHANGE_SERVICE = '@@b2b_portal_ui/table/OPEN_MOBILE_CHANGE_SERVICE';
export const OPEN_FOOTER_WIZARD_EXPENSES_DETAIL = '@@b2b_portal_ui/table/OPEN_FOOTER_WIZARD_EXPENSES_DETAIL';
export const OPEN_MOBILE_CASH = '@@b2b_portal_ui/table/OPEN_MOBILE_CASH';
export const LOAD_MOBILE_CASH = '@@b2b_portal_ui/table/LOAD_MOBILE_CASH';
export const MOBILE_CASH_FILE_LOADING = '@@b2b_portal_ui/table/MOBILE_CASH_FILE_LOADING';
export const MOBILE_CASH_FILE_SUCCESSFULL = '@@b2b_portal_ui/table/MOBILE_CASH_FILE_SUCCESSFULL';

/*
* -------------------------------------------
*        UPDATE ROWS
* -------------------------------------------
*/

export const UPDATE_ROWS_START = '@@b2b_portal_ui/table/UPDATE_ROWS_START';
export const UPDATE_ROWS_START_SUCCESSFUL = '@@b2b_portal_ui/table/UPDATE_ROWS_START_SUCCESSFUL';
export const UPDATE_ROWS_START_FAILURE = '@@b2b_portal_ui/table/UPDATE_ROWS_START_FAILURE';

/*
* -------------------------------------------
*        FOOTER TICK
* -------------------------------------------
*/

export const START_TICK = '@@b2b_portal_ui/table/START_TICK';
export const STOP_TICK = '@@b2b_portal_ui/table/STOP_TICK';

/*
* -------------------------------------------
*        PROXY
* -------------------------------------------
*/

export const RESET_BASKET = '@@b2b_portal_ui/table/RESET_BASKET';
export const RESET_BASKET_SUCCESS = '@@b2b_portal_ui/table/RESET_BASKET_SUCCESS';

/*
* -------------------------------------------
*        SET RANGE MONTH FILTER
* -------------------------------------------
*/
export const SET_RANGE_MONTH_FILTER = '@@b2b_portal_ui/table/SET_RANGE_MONTH_FILTER';
export const SET_RANGE_MONTH_FILTER_SUCCESS = '@@b2b_portal_ui/table/SET_RANGE_MONTH_FILTER_SUCCESS';

/*
* -------------------------------------------
*        RESET BASKET COUNT
* -------------------------------------------
*/

export const RESET_BASKET_COUNT = '@@b2b_portal_ui/table/RESET_BASKET_COUNT';

/*
* -------------------------------------------
*        SET TABLE IS LOADING
* -------------------------------------------
*/

export const SET_TABLE_IS_LOADING = '@@b2b_portal_ui/table/SET_TABLE_IS_LOADING';

/*
* -------------------------------------------
*        REMOVE ROW
* -------------------------------------------
*/

export const TABLE_REMOVE_ROW_ACTION = '@@b2b_portal_ui/table/REMOVE_ROW_ACTION';
export const TABLE_REMOVE_ROW_FAILURE = '@@b2b_portal_ui/table/REMOVE_ROW_FAILURE';
export const TABLE_REMOVE_ROW_SUCCESS = '@@b2b_portal_ui/table/REMOVE_ROW_SUCCESS';
export const TABLE_MODAL_OPEN_REMOVE = '@@b2b_portal_ui/table/MODAL_OPEN_REMOVE';

/*
* -------------------------------------------
*        RESET TABLE
* -------------------------------------------
*/

export const TABLE_RESET = '@@b2b_portal_ui/table/RESET';

/*
* -------------------------------------------
*        BUTTONS MODE
* -------------------------------------------
*/

export const TABLE_BUTTONS_SET_MODE = '@@b2b_portal_ui/table/TABLE_BUTTONS_SET_MODE';

/*
* -------------------------------------------
*        DELETE ROW IN TABLE
* -------------------------------------------
*/

export const TABLE_ROW_DELETE_ACTION = '@@b2b_portal_ui/table/TABLE_ROW_DELETE_ACTION';
export const TABLE_ROW_RESTORE_ACTION = '@@b2b_portal_ui/table/TABLE_ROW_RESTORE_ACTION';
export const TABLE_ROW_RESTORE_ALL_ACTION = '@@b2b_portal_ui/table/TABLE_ROW_RESTORE_ALL_ACTION';
